import * as types from "./types";

export const getApplicantsRequest = (payload) => ({
  type: types.GET_APPLICANTS_REQUEST,
  payload,
});
export const getApplicantsResponse = (payload) => ({
  type: types.GET_APPLICANTS_RESPONSE,
  payload,
});

export const getApplicantRequest = (payload) => ({
  type: types.GET_APPLICANT_REQUEST,
  payload,
});
export const getApplicantResponse = (payload) => ({
  type: types.GET_APPLICANT_RESPONSE,
  payload,
});

export const updateApplicant = (payload) => ({
  type: types.UPDATE_APPLICANT,
  payload,
});

export const updateApplicantProfileRequest = (payload) => ({
  type: types.UPDATE_APPLICANT_REQUEST,
  payload,
});

export const updateApplicantProfileResponse = (payload) => ({
  type: types.UPDATE_APPLICANT_RESPONSE,
  payload,
});

export const getEligibleApplicantsRequest = (payload) => ({
  type: types.GET_ELIGIBLE_APPLICANTS_REQUEST,
  payload,
});

export const getEligibleApplicantsResponse = (payload) => ({
  type: types.GET_ELIGIBLE_APPLICANTS_RESPONSE,
  payload,
});

export const updateApplicantDeductionRequest = (payload) => ({
  type: types.UPDATE_APPLICANT_DEDUCTION_REQUEST,
  payload,
});

export const updateApplicantDeductionResponse = (payload) => ({
  type: types.UPDATE_APPLICANT_DEDUCTION_RESPONSE,
  payload,
});

export const updateApplicantRewardRequest = (payload) => ({
  type: types.UPDATE_APPLICANT_REWARD_REQUEST,
  payload,
});

export const updateApplicantRewardResponse = (payload) => ({
  type: types.UPDATE_APPLICANT_REWARD_RESPONSE,
  payload,
});

export const updateApplicantRevertRewardRequest = (payload) => ({
  type: types.UPDATE_APPLICANT_REVERT_REWARD_REQUEST,
  payload,
});

export const updateApplicantRevertRewardResponse = (payload) => ({
  type: types.UPDATE_APPLICANT_REVERT_REWARD_RESPONSE,
  payload,
});

export const updateApplicantRevertDeductionRequest = (payload) => ({
  type: types.UPDATE_APPLICANT_REVERT_DEDUCTION_REQUEST,
  payload,
});

export const updateApplicantRevertDeductionResponse = (payload) => ({
  type: types.UPDATE_APPLICANT_REVERT_DEDUCTION_RESPONSE,
  payload,
});

export const promoteApplicantRequest = (payload) => ({
  type: types.PROMOTE_APPLICANT_REQUEST,
  payload,
});

export const promoteApplicantResponse = (payload) => ({
  type: types.PROMOTE_APPLICANT_RESPONSE,
  payload,
});

export const demoteApplicantRequest = (payload) => ({
  type: types.DEMOTE_APPLICANT_REQUEST,
  payload,
});

export const demoteApplicantResponse = (payload) => ({
  type: types.DEMOTE_APPLICANT_RESPONSE,
  payload,
});

export const getApplicantListingProfileRequest = (payload) => ({
  type: types.GET_CHECK_LISTING_PROFILE_REQUEST,
  payload: payload.user_ids,
});

export const getApplicantListingProfileResponse = (payload) => ({
  type: types.GET_CHECK_LISTING_PROFILE_RESPONSE,
  payload,
});
